// src/store/authStore.js
import { reactive, readonly } from 'vue';

// Estado inicial
const state = reactive({
  isAuthenticated: !!localStorage.getItem('accessToken'),
  username: localStorage.getItem('username') || '',
  isAdmin: localStorage.getItem('isAdmin') === 'true'
});

// Acciones y mutaciones
const actions = {
  setUser(userData) {
    state.isAuthenticated = true;
    state.username = userData.username;
    state.isAdmin = userData.isAdmin;
  },
  
  clearUser() {
    state.isAuthenticated = false;
    state.username = '';
    state.isAdmin = false;
  },
  
  updateUsername(username) {
    state.username = username;
  }
};

// Exponer el estado como readonly para consumo externo
export default {
  state: readonly(state),
  ...actions
};